// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/jobDocumentSpec.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9740: ONE field list for the driver-signed Bill of Lading / Disposal
// Ticket — the phone form, the server validation and the PDF agree by construction.)
//
// Imported ONLY by public/src/views/jobboard.js. The body below is the
// canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================

var JOB_DOCUMENT_KINDS = ['bol', 'disposal'];

var JOB_DOCUMENT_KIND_LABELS = {
  bol: 'Bill of Lading',
  disposal: 'Disposal Ticket',
};

var JOB_DOCUMENT_UNIT_OPTIONS = ['loads', 'bbl', 'gal', 'tons', 'lbs', 'yd3', 'ea', 'pcs', 'ft', 'joints'];

// The maximum length of any single value. Long enough for an address block or
// a paragraph of notes, short enough that a doc of 20 fields plus two
// signature PNGs stays far under Firestore's 1 MB document cap.
var JOB_DOCUMENT_FIELD_MAX = 1000;

// TASK-9740 harvest 10/13 — hazardous materials on the Bill of Lading
// (49 CFR 172.202 shipping-paper description + 172.604 emergency response
// phone). The ZL Chemicals BOLs Chris sent (WACS1073-1076, friction reducer,
// not hazmat) carry no hazmat block, so the block is modelled on the
// regulation, not on that paper. Every hazmat field is OPTIONAL unless the
// job is marked hazmat (job.hazmat === true, the Edit Job DOT flag) — then
// all of them are required. A field filled on a non-hazmat job is still
// checked for shape. Field ids start with 'hm' and carry hazmat: true.
var JOB_DOCUMENT_HAZARD_CLASSES = ['1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '2.1', '2.2', '2.3', '3', '4.1', '4.2', '4.3', '5.1', '5.2', '6.1', '6.2', '7', '8', '9', 'Combustible liquid'];
var JOB_DOCUMENT_PACKING_GROUPS = ['I', 'II', 'III', 'None'];
var JOB_DOCUMENT_HM_QTY_UNITS = ['gal', 'L', 'bbl', 'lbs', 'kg', 'cu ft', 'm3'];

var JOB_DOCUMENT_FIELDS = {
  bol: [
    { id: 'shipper', label: 'Shipper', type: 'textarea', required: true, hint: 'Who the load is from (name + address)' },
    { id: 'consignee', label: 'Consignee', type: 'textarea', required: true, hint: 'Who the load is to (name + address)' },
    { id: 'pickup', label: 'Pickup location', type: 'text', required: false },
    { id: 'delivery', label: 'Delivery location', type: 'text', required: false },
    { id: 'commodity', label: 'Commodity / description', type: 'textarea', required: true },
    { id: 'quantity', label: 'Quantity', type: 'number', required: true },
    { id: 'unit', label: 'Unit', type: 'select', required: true, options: JOB_DOCUMENT_UNIT_OPTIONS },
    { id: 'containerId', label: 'Container / ISO / trailer ID', type: 'text', required: false },
    { id: 'poNumber', label: 'PO #', type: 'text', required: false, hint: 'Leave the job PO unless the paper shows a different one — a different PO is sent to the office to check' },
    { id: 'notes', label: 'Notes', type: 'textarea', required: false },
    { id: 'hmUnNumber', label: 'UN / NA ID number', type: 'text', required: false, hazmat: true, pattern: 'unna', hint: 'e.g. UN1203 (172.202(a)(1))' },
    { id: 'hmShippingName', label: 'Proper shipping name', type: 'textarea', required: false, hazmat: true, hint: 'From the 172.101 table (172.202(a)(2))' },
    { id: 'hmHazardClass', label: 'Hazard class / division', type: 'select', required: false, hazmat: true, options: JOB_DOCUMENT_HAZARD_CLASSES },
    { id: 'hmPackingGroup', label: 'Packing group', type: 'select', required: false, hazmat: true, options: JOB_DOCUMENT_PACKING_GROUPS, hint: 'None for classes with no packing group' },
    { id: 'hmQuantity', label: 'Hazmat total quantity', type: 'number', required: false, hazmat: true },
    { id: 'hmQuantityUnit', label: 'Hazmat quantity unit', type: 'select', required: false, hazmat: true, options: JOB_DOCUMENT_HM_QTY_UNITS },
    { id: 'hmPackages', label: 'Number and type of packages', type: 'text', required: false, hazmat: true, hint: 'e.g. 1 cargo tank (172.202(a)(7))' },
    { id: 'hmEmergencyPhone', label: '24-hour emergency response phone', type: 'text', required: false, hazmat: true, pattern: 'phone', hint: 'Monitored at all times while in transit (172.604)' },
  ],
  disposal: [
    { id: 'generator', label: 'Generator', type: 'textarea', required: true, hint: 'Who the material is from (name + address)' },
    { id: 'facility', label: 'Disposal facility', type: 'textarea', required: true, hint: 'Where it was taken (name + address)' },
    { id: 'pickup', label: 'Pickup location', type: 'text', required: false },
    { id: 'material', label: 'Material / waste description', type: 'textarea', required: true },
    { id: 'volume', label: 'Volume', type: 'number', required: true },
    { id: 'unit', label: 'Unit', type: 'select', required: true, options: JOB_DOCUMENT_UNIT_OPTIONS },
    { id: 'manifestNo', label: 'Manifest #', type: 'text', required: false },
    { id: 'facilityTicketNo', label: 'Facility ticket #', type: 'text', required: false },
    { id: 'poNumber', label: 'PO #', type: 'text', required: false },
    { id: 'notes', label: 'Notes', type: 'textarea', required: false },
  ],
};

function jobDocumentKindLabel(kind) {
  return JOB_DOCUMENT_KIND_LABELS[kind] || '';
}

function jobDocumentFieldsFor(kind) {
  return JOB_DOCUMENT_FIELDS[kind] || [];
}

// Normalises + checks a submitted `fields` map against the kind's spec.
// Returns { ok, errors: [{ id, message }], clean: { id: value } }. `clean`
// holds ONLY spec'd ids (an unknown key is dropped, never stored), every value
// trimmed and capped. A required field that is blank is an error; a select
// value outside its options is an error; a number field that is not a plain
// number is an error. Client and server run this same function.
// opts.hazmat === true (the job is marked hazmat) makes every hazmat field
// required; otherwise they are optional but still shape-checked when filled.
function validateJobDocumentFields(kind, fields, opts) {
  var hazmat = !!(opts && opts.hazmat === true);
  var spec = jobDocumentFieldsFor(kind);
  var errors = [];
  var clean = {};
  if (!spec.length) return { ok: false, errors: [{ id: 'kind', message: 'Unknown document type' }], clean: clean };
  var src = (fields && typeof fields === 'object') ? fields : {};
  for (var i = 0; i < spec.length; i++) {
    var f = spec[i];
    var raw = src[f.id];
    var v = (raw == null) ? '' : String(raw);
    // Control characters never reach the stored doc (they fail open in
    // painters and regexes); tabs/newlines survive in a textarea.
    v = v.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '').trim();
    if (v.length > JOB_DOCUMENT_FIELD_MAX) v = v.slice(0, JOB_DOCUMENT_FIELD_MAX);
    if (!v) {
      if (f.required || (hazmat && f.hazmat)) errors.push({ id: f.id, message: f.label + ' is required' + (f.hazmat && !f.required ? ' on a hazmat load' : '') });
      continue;
    }
    if (f.pattern === 'unna') {
      v = v.toUpperCase().replace(/\s+/g, '');
      if (!/^(UN|NA)\d{4}$/.test(v)) { errors.push({ id: f.id, message: f.label + ' must look like UN1203 or NA1993' }); continue; }
    }
    if (f.pattern === 'phone' && v.replace(/\D/g, '').length < 10) {
      errors.push({ id: f.id, message: f.label + ' must be a full phone number' });
      continue;
    }
    if (f.type === 'select' && f.options && f.options.indexOf(v) < 0) {
      errors.push({ id: f.id, message: f.label + ' must be one of ' + f.options.join(', ') });
      continue;
    }
    if (f.type === 'number' && !/^\d{1,9}(\.\d{1,4})?$/.test(v)) {
      errors.push({ id: f.id, message: f.label + ' must be a number' });
      continue;
    }
    clean[f.id] = v;
  }
  return { ok: errors.length === 0, errors: errors, clean: clean };
}

// TASK-9740 harvest 10/13 — does any hazmat field carry a value?
function jobDocumentHasHazmat(clean) {
  var c = (clean && typeof clean === 'object') ? clean : {};
  var all = jobDocumentFieldsFor('bol');
  for (var i = 0; i < all.length; i++) if (all[i].hazmat && c[all[i].id]) return true;
  return false;
}

// TASK-9740 harvest 10/13 — the job's PO stays the PO. A PO the driver typed
// that is not the job's (spaces and letter case ignored) is a second,
// driver-entered PO the office must check. Returns '' when there is nothing
// to flag (blank, or the same PO), else the typed value.
function jobDocumentDriverPo(jobPo, typedPo) {
  var norm = function (x) { return String(x == null ? '' : x).replace(/\s+/g, '').toUpperCase(); };
  var t = String(typedPo == null ? '' : typedPo).trim();
  if (!t) return '';
  return norm(t) === norm(jobPo) ? '' : t;
}

// A human document number: BOL-K3F9Q2 / DT-K3F9Q2. Derived from the creation
// time in base36 plus the tail of the Firestore id, so it is unique per doc
// and readable off a phone screen. Not sequential on purpose: sequential
// numbering needs a counter transaction, and an offline submission cannot run
// one. The office keys on the Firestore id; this is what people say out loud.
function jobDocumentNumber(kind, createdAtMs, docId) {
  var prefix = kind === 'disposal' ? 'DT' : 'BOL';
  var t = Math.max(0, Math.floor(Number(createdAtMs) || 0)).toString(36).toUpperCase();
  var tail = String(docId || '').replace(/[^A-Za-z0-9]/g, '').slice(-3).toUpperCase();
  return prefix + '-' + t.slice(-5) + tail;
}

export { JOB_DOCUMENT_KINDS, JOB_DOCUMENT_KIND_LABELS, JOB_DOCUMENT_UNIT_OPTIONS, JOB_DOCUMENT_FIELD_MAX, JOB_DOCUMENT_FIELDS, JOB_DOCUMENT_HAZARD_CLASSES, JOB_DOCUMENT_PACKING_GROUPS, JOB_DOCUMENT_HM_QTY_UNITS, jobDocumentKindLabel, jobDocumentFieldsFor, validateJobDocumentFields, jobDocumentNumber, jobDocumentHasHazmat, jobDocumentDriverPo };
